<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      class="simple-add-table mb-4"
      sort-by="fullname"
      sort-asc
      dense
      :loading="loading.load"
      loading-text="Загрузка... Пожалуйста подождите"
      :items-per-page="-1"
      :height="428"
      hide-default-footer
      hide-default-header
      :custom-sort="customSort"
    >
      <template v-slot:header>
        <tr>
          <td class="border-bottom pa-4" style="width: 60px">
              <v-checkbox
                :input-value="selected.length"
                @change="onChangeAllCheck"
                :indeterminate="!!selected.length && selected.length !== managers.length"
                hide-details
                class="mt-auto"
              />
          </td>

          <td class="border-bottom pa-3" >
            <v-text-field label="Фильтр" append-icon="mdi-magnify" class="font-sm" v-model="filterName" dense hide-details outlined />
          </td>
        </tr>
      </template>

      <!--  Cells  -->
      <template v-slot:item.check="{ item }">
        <v-checkbox :input-value="selected.some(id => id === item.id)" @change="setSelected(item.id)" hide-details class="mt-auto" />
      </template>

      <template v-slot:item.fullname="{ item }">
        {{ item.last_name }} {{ item.first_name }}
      </template>

      <template v-slot:no-data> Менеджеров не найдено. </template>

    </v-data-table>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ManagersTableSimple',
  components: {
  },
  props: {
    selected: Array,
  },
  data: () => ({
    filterName: '',
    headers: [
      {  text: '', value: 'check', sortable: false, },
      {  text: 'Фамилия и Имя', value: 'fullname', sortable: false, },
    ],
  }),
  computed: {
    ...mapGetters({
      loading: 'users/managers/loading',
      managers: 'users/managers/managers',
    }),
    filteredItems() {
      return this.filterName ?
        this.managers.filter(el=> (el.last_name+' '+el.first_name).toLowerCase().includes(this.filterName.toLowerCase()))
        : this.managers
    }

  },
  methods: {
    ...mapActions({
    }),
    ...mapMutations({
    }),

    setSelected(id) {
      const itemFound = this.selected.findIndex((item) => item === id);
      if (itemFound >= 0) {
        this.selected.splice(itemFound, 1);
      } else {
        this.selected.push(id);
      }
    },
    onChangeAllCheck(bool) {
      if (bool) {
        this.managers.forEach(el => {
          const itemFound = this.selected.findIndex((item) => item === el.id);
          if (itemFound < 0) {
            this.selected.push(el.id);
          }
        });
      } else {
        this.selected.splice(0, this.selected.length);
      }
    },
    customSort(items, [index], [isDesc]) {
      items.sort((a, b) => {
        if (index === 'fullname') {
          const aname = a.last_name || a.first_name ? `${a.last_name} ${a.first_name}` : 'Я';
          const bname = b.last_name || b.first_name ? `${b.last_name} ${b.first_name}` : 'Я';
          return !isDesc ? aname.localeCompare(bname) : bname.localeCompare(aname);
        }
        if (index === 'company') {
          const aname = a.customer && a.customer.company ? a.customer.company : 'Z';
          const bname = b.customer && b.customer.company ? b.customer.company : 'Z';
          return !isDesc ? aname.localeCompare(bname) : bname.localeCompare(aname);
        }
        return b[index] < a[index] ? -1 : 1;
      });
      return items;
    },

  },
  created() {
  },
};
</script>

<style lang="scss">
</style>
